
import request from '@/utils/ajax';

export function createProduct(data) {
  return request({
    url: '/pms/crm/createProduct',
    method: 'post',
    data,
  });
}


export function updateProduct(data) {
  return request({
    url: '/pms/crm/updateProduct',
    method: 'put',
    data,
  });
}

// 新增渠道关联关系
export function createProdChannelRelation(data) {
  return request({
    url: '/pms/crm/createProdChannelRelation',
    method: 'post',
    data,
  });
}

//
export function updateMerProdRelation(data) {
  return request({
    url: '/pms/crm/updateProdChannelRelation',
    method: 'put',
    data,
  });
}

// 有效产品列表
export function queryValidProducts(data) {
  return request({
    url: '/pms/crm/allProduct',
    method: 'get',
    params: data
  });
}
